import { useCallback, useEffect, useState } from "react";
import { dark, light, main } from "../../../style/themes";

export const useThemeToggle = () => {
  const [themeName, setThemeName] = useState("main");
  const [theme, setTheme] = useState(main);
  const [componentMounted, setComponentMounted] = useState(false);

  const setThemeFromName = (themeName) => {
    if (themeName === "light") {
      setTheme(light);
    } else if (themeName === "dark") {
      setTheme(dark);
    } else {
      setTheme(main);
    }
  };

  const changeTheme = useCallback((themeName) => {
    window.localStorage.setItem("theme", themeName);
    setThemeName(themeName);
    setThemeFromName(themeName);
  }, []);

  useEffect(() => {
    const localTheme = window.localStorage.getItem("theme");
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches &&
      !localTheme
    ) {
      // changeTheme("dark");
      console.log("would change theme to dark")
    } else {
      if (localTheme) {
        changeTheme(localTheme);
      } else {
        changeTheme(themeName);
      }
    }
    setComponentMounted(true);
  }, [themeName, changeTheme]);

  return [theme, themeName, changeTheme, componentMounted];
};
